var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "recipient-select" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("wp.sendMessageTo")))]),
        _vm._v(" "),
        _c(
          "a-radio-group",
          {
            attrs: { "default-value": _vm.target },
            on: { change: _vm.onChange },
          },
          [
            !_vm.value.channel
              ? _c("a-radio-button", { attrs: { value: "all" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("wp.allContact"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("a-radio-button", { attrs: { value: "customer-groups" } }, [
              _vm._v(_vm._s(_vm.$t("wp.customerGroups"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _vm.target === "all"
        ? _c(
            "div",
            [
              _c("a-table", {
                key: "vtable-" + _vm.renderCount,
                staticClass: "custom-table",
                attrs: {
                  columns: _vm.cols,
                  dataSource: _vm.contactList,
                  pagination: _vm.pagination,
                  locale: {
                    emptyText: _vm.$t("message.noContactFound"),
                  },
                  rowKey: "id",
                  size: "large",
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "avatarSlot",
                      fn: function (data, item) {
                        return _c(
                          "div",
                          { staticClass: "p-1" },
                          [
                            _c(
                              "a-avatar",
                              {
                                staticStyle: {
                                  "background-color": "#3899ff",
                                  "border-radius": "7px !important",
                                },
                                attrs: {
                                  size: 30,
                                  shape: "square",
                                  username: item.name,
                                  src: _vm.$_.get(
                                    item,
                                    "profilePicThumbObj.eurl"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      item.name.substr(0, 1).toLocaleUpperCase()
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  3036427111
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.target === "customer-groups"
        ? _c(
            "div",
            [
              _c("CustomerGroupsPicker", {
                attrs: {
                  "on-select-changed": _vm.onGroupSelected,
                  "default-selected-group-id": _vm.clone.groupId,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }